import React, {useEffect, useState} from "react";
import "./App.css";
import {Route, Switch} from "react-router-dom";
import TasksOverview from "./overview/TasksOverview";
import TaskDetails from "./taskExecution/TaskDetails";
import {getUserName} from "../handlers/ParentDataHandler";
import {AMAZON_SUFFIX} from "../utils/Constants";
import useContextStore from "../stores/ContextStore";
import {DeviceLayoutProvider} from './common/context/DeviceLayoutContext';
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import { getDarkModeStatus, setDarkModeStateListener } from "../handlers/ParentDataHandler";

function App() {
  const setUsername = useContextStore(state => state.setUsername);
  const [currentDarkMode, setCurrentDarkMode] = useState("light");

  useEffect(() => {
    initUsername(setUsername);
    setDarkModeStateListener(setCurrentDarkMode);
    getDarkModeStatus();
  }, [])

  return (
    <Theme
      tokens={currentDarkMode === "dark" ? blueDarkTokens : blueLightTokens}
    >
      <DeviceLayoutProvider>
        <Switch>
          <Route path="/overview" component={TasksOverview} />
          <Route path="/task/:taskId" component={TaskDetails} />
        </Switch>
      </DeviceLayoutProvider>
    </Theme>
  );
}

const initUsername = (setUsername) => {
  getUserName().then(response => {
    let username = JSON.parse(response.name) || "";
    if (username.endsWith(AMAZON_SUFFIX)) {
      username = username.substring(0, username.length - AMAZON_SUFFIX.length);
    }
    setUsername(username);
  });
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js